import { Link } from "react-router-dom";

export default function HomePage() {
  return (
    <section className="flex flex-col items-center gap-8 py-8 text-center">
      <div className="max-w-2xl">
        <h1 className="text-3xl font-semibold tracking-tight text-gray-900 sm:text-4xl">
          Quality patios, built for Queensland conditions
        </h1>
        <p className="mt-4 text-base text-gray-600">
          Tell us about your project and we&apos;ll prepare an obligation-free budget. Add a few
          photos of your space and we can be more accurate, faster.
        </p>
      </div>
      <Link
        to="/enquire"
        className="inline-flex h-12 items-center justify-center rounded-md bg-indigo-600 px-8 text-base font-medium text-white shadow-sm transition-colors hover:bg-indigo-700 focus-visible:ring-2 focus-visible:ring-indigo-500/50"
      >
        Get a Free Quote
      </Link>
      <dl className="mt-4 grid w-full max-w-3xl grid-cols-1 gap-4 sm:grid-cols-3">
        {[
          ["No account needed", "Send your enquiry in a couple of minutes — no sign-up."],
          ["Response in 2 business days", "A local rep reviews every enquiry and gets back to you."],
          ["Photos welcome", "Optional photos help us prepare a more accurate budget."],
        ].map(([title, body]) => (
          <div key={title} className="rounded-lg border border-gray-200 bg-white p-5 text-left shadow-sm">
            <dt className="text-sm font-medium text-gray-900">{title}</dt>
            <dd className="mt-1 text-sm text-gray-600">{body}</dd>
          </div>
        ))}
      </dl>
    </section>
  );
}
